import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../AbstractElements';
import DataGridItemWiseView from './DataGridItemWiseView';
import { Container } from 'reactstrap';

const ItemGrid = () => {
    // The "Live" suffix only disambiguates from the UAT grid, which only Backend
    // Users can see - everyone else just gets the plain name.
    const isBackendUser = localStorage.getItem("usertype") === "Backend User";
    const pageTitle = isBackendUser ? "Item Grid - Live" : "Item Grid";
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={pageTitle} title={pageTitle} mainTitle={pageTitle} />
                <Container fluid={true}>
                    <DataGridItemWiseView />
                </Container>
            </Fragment>
        </UL>
    )
}

export default ItemGrid
